import React, { useState, useEffect } from 'react';
import { superAdminApi } from '../../services/superAdminApi';
import ClientStats from '../../components/super-admin/ClientStats';
import SignupRequestsTable from '../../components/super-admin/SignupRequestsTable';
import TenantsTable from '../../components/super-admin/TenantsTable';
import CreateTenantModal from '../../components/super-admin/CreateTenantModal';

const ClientManagement = () => {
  const [activeTab, setActiveTab] = useState('active');
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);

  useEffect(() => {
    fetchDashboardStats();
  }, []);

  const fetchDashboardStats = async () => {
    try {
      setLoading(true);
      const response = await superAdminApi.getDashboardStats();
      setStats(response.data.stats);
    } catch (error) {
      console.error('Failed to fetch dashboard stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleTenantCreated = () => {
    fetchDashboardStats();
    setShowCreateModal(false);
  };

  const tabs = [
    { id: 'requests', label: 'Signup Requests', icon: 'envelope' },
    { id: 'active', label: 'Active Clients', icon: 'users' },
    { id: 'suspended', label: 'Suspended', icon: 'pause-circle' },
    { id: 'all', label: 'All Tenants', icon: 'building' }
  ];

  return (
    <div className="client-management">
      <div className="page-header">
        <div className="header-content">
          <h1>Client Management</h1>
          <p>Manage client signups, approvals, and tenant configuration</p>
        </div>
        <div className="header-actions">
          <button 
            className="btn-primary"
            onClick={() => setShowCreateModal(true)}
          >
            <i className="fas fa-plus"></i>
            Add New Tenant
          </button>
        </div>
      </div>

      {/* Statistics Dashboard */}
      <ClientStats stats={stats} loading={loading} />

      {/* Tab Navigation */}
      <div className="management-tabs">
        <div className="tab-header">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <i className={`fas fa-${tab.icon}`}></i>
              {tab.label}
              {stats && (
                <span className="tab-count">
                  {getTabCount(tab.id, stats)}
                </span>
              )}
            </button>
          ))}
        </div>

        <div className="tab-content">
          {activeTab === 'requests' && (
            <SignupRequestsTable 
              onRequestProcessed={fetchDashboardStats}
            />
          )}
          
          {activeTab === 'active' && (
            <TenantsTable 
              status="active"
              onTenantUpdated={fetchDashboardStats}
            />
          )}
          
          {activeTab === 'suspended' && (
            <TenantsTable 
              status="suspended"
              onTenantUpdated={fetchDashboardStats}
            />
          )}
          
          {activeTab === 'all' && (
            <TenantsTable 
              status="all"
              onTenantUpdated={fetchDashboardStats}
            />
          )}
        </div>
      </div>

      {/* Create Tenant Modal */}
      {showCreateModal && (
        <CreateTenantModal
          onClose={() => setShowCreateModal(false)}
          onTenantCreated={handleTenantCreated}
        />
      )}
    </div>
  );
};

// Helper function to get count for each tab
const getTabCount = (tabId, stats) => {
  if (!stats) return '';
  
  switch (tabId) {
    case 'requests':
      return stats.pending_requests;
    case 'active':
      return stats.active_tenants;
    case 'suspended':
      return stats.suspended_tenants;
    case 'all':
      return stats.total_tenants;
    default:
      return '';
  }
};

export default ClientManagement;